import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RequestPasswordResetForm } from "../../components/auth";
import { useAuth } from "../../hooks";
import AuthLayout from "../../layouts/AuthLayout";

const RequestPasswordResetPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already authenticated, redirect to home page
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <AuthLayout title="Reset Password">
      <RequestPasswordResetForm />
    </AuthLayout>
  );
};

export default RequestPasswordResetPage;
